// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__YRyOQ","modal":"styles_modal__1oK77","close":"styles_close__1Jee1"};